import { Completed, Draft, Expired, Pending, Submitted, Unlocked } from '../../../shared/Assets/sessionStatuses';
import { PRIMARY } from '../../../shared/Helpers/colors';
import { SessionType } from '../../../shared/Helpers/constants';

const ASSESMENT = `linear-gradient(0deg, rgba(106, 176, 186, 0.16) 0%, rgba(106, 176, 186, 0.16) 100%), #FFF`;
const TREATMENT_PLANNING = `linear-gradient(0deg, rgba(81, 138, 224, 0.16) 0%, rgba(81, 138, 224, 0.16) 100%), #FFF`;
const BEHAVIOR_TREATMENT = `linear-gradient(0deg, rgba(186, 142, 106, 0.16) 0%, rgba(186, 142, 106, 0.16) 100%), #FFF`;
const DIRECT_SUPERVISION = `linear-gradient(0deg, rgba(165, 106, 186, 0.16) 0%, rgba(165, 106, 186, 0.16) 100%), #FFF`;
const BEHAVIOR_TREATMENT_MODIFICATION = `linear-gradient(0deg, rgba(230, 130, 122, 0.16) 0%, rgba(230, 130, 122, 0.16) 100%), #FFF`;
const PARENT_TRANING = `linear-gradient(0deg, rgba(97, 95, 255, 0.16) 0%, rgba(97, 95, 255, 0.16) 100%), #FFF`;
const MEET_AND_GREET = `linear-gradient(0deg, rgba(188, 158, 133, 0.16) 0%, rgba(188, 158, 133, 0.16) 100%), #FFF`;
const MEET_AND_GREET_NON_BILLABLE = `linear-gradient(0deg, rgba(152, 88, 35, 0.16) 0%, rgba(152, 88, 35, 0.16) 100%), #FFF`;
const DISCRETIONARY_SESSION = `linear-gradient(0deg, rgba(34, 197, 94, 0.16) 0%, rgba(34, 197, 94, 0.16) 100%), #FFF`;
const BCBA_BT_INTRO_CALL = `linear-gradient(0deg, rgba(14, 165, 233, 0.16) 0%, rgba(14, 165, 233, 0.16) 100%), #FFF`;

export const sessionTypeColors = [
	{ type: SessionType.Assessment, color: ASSESMENT, iconColor: PRIMARY.BASE },
	{ type: SessionType.TreatmentPlanning, color: TREATMENT_PLANNING, iconColor: `rgba(81, 138, 224, 1)` },
	{ type: SessionType.BehaviorTreatment, color: BEHAVIOR_TREATMENT, iconColor: `rgba(186, 142, 106, 1)` },
	{ type: SessionType.DirectSupervision, color: DIRECT_SUPERVISION, iconColor: `rgba(165, 106, 186, 1)` },
	{
		type: SessionType.BehaviorTreatmentModification,
		color: BEHAVIOR_TREATMENT_MODIFICATION,
		iconColor: `rgba(230, 130, 122, 1)`,
	},
	{ type: SessionType.ParentTraining, color: PARENT_TRANING, iconColor: `rgba(97, 95, 255, 1)` },
	{ type: SessionType.MeetAndGreet, color: MEET_AND_GREET, iconColor: `rgba(188, 158, 133, 1)` },
	{
		type: SessionType.MeetAndGreetNonBillable,
		color: MEET_AND_GREET_NON_BILLABLE,
		iconColor: `rgba(152, 88, 35, 1)`,
	},
	{ type: SessionType.DiscretionarySession, color: DISCRETIONARY_SESSION, iconColor: `rgba(34, 197, 94, 1)` },
	{ type: SessionType.BcbaBtIntroCall, color: BCBA_BT_INTRO_CALL, iconColor: `rgba(14, 165, 233, 1)` },
];

export const months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const weeks = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const monthByNumber = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export const monthDays = [
	'00',
	'01',
	'02',
	'03',
	'04',
	'05',
	'06',
	'07',
	'08',
	'09',
	'10',
	'11',
	'12',
	'13',
	'14',
	'15',
	'16',
	'17',
	'18',
	'19',
	'20',
	'21',
	'22',
	'23',
	'24',
	'25',
	'26',
	'27',
	'28',
	'29',
	'30',
	'31',
];

export const minutes = [
	'00',
	'01',
	'02',
	'03',
	'04',
	'05',
	'06',
	'07',
	'08',
	'09',
	'10',
	'11',
	'12',
	'13',
	'14',
	'15',
	'16',
	'17',
	'18',
	'19',
	'20',
	'21',
	'22',
	'23',
	'24',
	'25',
	'26',
	'27',
	'28',
	'29',
	'30',
	'31',
	'32',
	'33',
	'34',
	'35',
	'36',
	'37',
	'38',
	'39',
	'40',
	'41',
	'42',
	'43',
	'44',
	'45',
	'46',
	'47',
	'48',
	'49',
	'50',
	'51',
	'52',
	'53',
	'54',
	'55',
	'56',
	'57',
	'58',
	'59',
];

export const SESSION_STATUSES = [
	{ label: 'Draft', Icon: Draft },
	{ label: 'Submitted', Icon: Submitted },
	{ label: 'Expired', Icon: Expired },
	{ label: 'Unlocked', Icon: Unlocked },
	{ label: 'Pending', Icon: Pending },
	{ label: 'Session completed, SOAP note not created', Icon: Completed },
];

export const hours = [
	'05:00 AM',
	'06:00 AM',
	'07:00 AM',
	'08:00 AM',
	'09:00 AM',
	'10:00 AM',
	'11:00 AM',
	'12:00 PM',
	'01:00 PM',
	'02:00 PM',
	'03:00 PM',
	'04:00 PM',
	'05:00 PM',
	'06:00 PM',
	'07:00 PM',
	'08:00 PM',
	'09:00 PM',
	'10:00 PM',
];
